module.exports = __webpack_public_path__ + "media/images/icon_list/menu-1ef9502e06ec3da5351c5df7135ea72d.svg";